<template>
  <div class="guide container">
    <!-- customer_id mobile source_type=dealer_pc-->
    <img src="@/assets/img/code_img.png" alt />
    <div class="btn" @click="link()">
      <span>
        点击跳转到另外一个模块进行操作哦
        <i class="el-icon-right"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.$get("dealer_pc", "/admin/login/dealer_login", {
      customer_id: sessionStorage.getItem("customer_id"),
      url_type: "guide",
    });
  },
  methods: {
    link() {
      this.$get("dealer_pc", "/admin/login/dealer_login", {
        customer_id: sessionStorage.getItem("customer_id"),
        url_type: "guide",
      })
        .then(() => {
          setTimeout(() => {
            window.open('https://yxfk.tx315.vip/index.php/admin/index/index')
          }, 500);
        })
        .catch(() => {
          this.$Toast("服务器错误");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.guide {
  padding-top: 50px;

  img {
    width: 536px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  .btn {
    text-align: center;
    padding-top: 40px;
    cursor: pointer;
    transition: all 1s;
    &:hover {
      transform: translate(-10px, -10px);
      > span {
        box-shadow: 16px 20px 20px 0px #eee;
        i {
          opacity: 1;
          transition: opacity 0.1s;
        }
      }
    }
    > span {
      padding: 15px 30px;
      border-radius: 25px;
      color: white;
      font-size: 18px;
      font-family: serif;
      box-shadow: 1px 6px 18px 0px #eee;
      border: 1px solid #f2f2f2;
      background-color: #009688;
      i {
        opacity: 0;
        transition: opacity 0.3s;
        color: rgb(0, 150, 136);
      }
    }
  }
}
</style>
